<template>
  <div>
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-position="top"
      v-loading="loading"
    >
      <div class="desc-wrapper">
        <div class="desc-info w-57">
          {{
            $t('text.day').slice(0, 1) +
              $t('text.day')
                .slice(1)
                .toLowerCase()
          }}
        </div>
      </div>
      <div class="time-period-selection">
        <el-form-item :label="$t('text.time_period')" prop="DayStartTime">
          <el-select
            v-model="form.DayStartTime"
            clearable
            :placeholder="$t('text.start')"
            @change="calculateNightSection"
          >
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="seperator">{{ $t('text.to').toLowerCase() }}</span>
        <el-form-item prop="DayEndTime">
          <el-select
            v-model="form.DayEndTime"
            clearable
            :placeholder="$t('text.end')"
            @change="calculateNightSection"
          >
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div v-if="manufacturers.length">
        <el-form-item prop="DayManufacturerId">
          <template slot="label">
            <span class="mr-10">{{ $t('text.manufacturer') }}</span>
            <el-button
              size="mini"
              class="p-3"
              type="primary"
              plain
              icon="el-icon-plus"
              @click="openDialog"
              v-if="p('Manufacturers.Add')"
            ></el-button>
          </template>
          <el-select
            v-model="form.DayManufacturerId"
            filterable
            :placeholder="$t('text.select')"
            class="wp-100"
            :loading="loading"
          >
            <el-option
              v-for="item in manufacturers"
              :key="item.id"
              :label="
                item.disabled
                  ? item.name + ' (' + $t('text.expired') + ')'
                  : item.name
              "
              :value="item.id"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.product')" prop="DayProductId">
          <el-select
            v-model="form.DayProductId"
            filterable
            :placeholder="$t('text.select')"
            :no-data-text="
              form.DayManufacturerId
                ? $t('text.no_data')
                : $t('text.please_select_manufacturer_first')
            "
            class="wp-100"
          >
            <el-option
              v-for="item in dayProductOptions"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item prop="DayManufacturerId" v-else>
        <div class="no-manufacturer-container v-h-center">
          <div class="text-center">
            <div>{{ $t('text.add_a_manufacturer_to_continue') }}</div>
            <el-button
              class="mt-20 green-btn"
              @click="openDialog"
              v-if="p('Manufacturers.Add')"
              >{{ $t('text.add_manufacturer') }}</el-button
            >
          </div>
        </div>
      </el-form-item>
      <div class="desc-wrapper">
        <div class="desc-info w-57">
          {{
            $t('text.night').slice(0, 1) +
              $t('text.night')
                .slice(1)
                .toLowerCase()
          }}
        </div>
      </div>
      <div class="time-period-selection">
        <el-form-item :label="$t('text.time_period')" prop="NightStartTime">
          <el-select
            v-model="form.NightStartTime"
            clearable
            :placeholder="$t('text.start')"
            @change="calculateDaySection"
          >
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="seperator">{{ $t('text.to').toLowerCase() }}</span>
        <el-form-item prop="NightEndTime">
          <el-select
            v-model="form.NightEndTime"
            clearable
            :placeholder="$t('text.end')"
            @change="calculateDaySection"
          >
            <el-option
              v-for="item in timeOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div v-if="manufacturers.length">
        <el-form-item prop="NightManufacturerId">
          <template slot="label">
            <span class="mr-10">{{ $t('text.manufacturer') }}</span>
            <el-button
              size="mini"
              class="p-3"
              type="primary"
              plain
              icon="el-icon-plus"
              @click="openDialog"
              v-if="p('Manufacturers.Add')"
            ></el-button>
          </template>
          <el-select
            v-model="form.NightManufacturerId"
            filterable
            :placeholder="$t('text.select')"
            class="wp-100"
            :loading="loading"
          >
            <el-option
              v-for="item in manufacturers"
              :key="item.id"
              :label="
                item.disabled
                  ? item.name + ' (' + $t('text.expired') + ')'
                  : item.name
              "
              :value="item.id"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.product')" prop="NightProductId">
          <el-select
            v-model="form.NightProductId"
            filterable
            :placeholder="$t('text.select')"
            :no-data-text="
              form.NightManufacturerId
                ? $t('text.no_data')
                : $t('text.please_select_manufacturer_first')
            "
            class="wp-100"
          >
            <el-option
              v-for="item in nightProductOptions"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item prop="NightManufacturerId" v-else>
        <div class="no-manufacturer-container v-h-center">
          <div class="text-center">
            <div>{{ $t('text.add_a_manufacturer_to_continue') }}</div>
            <el-button
              class="mt-20 green-btn"
              @click="openDialog"
              v-if="p('Manufacturers.Add')"
              >{{ $t('text.add_manufacturer') }}</el-button
            >
          </div>
        </div>
      </el-form-item>
      <div class="desc-wrapper">
        <div class="desc-info w-57">
          {{
            $t('text.other').slice(0, 1) +
              $t('text.other')
                .slice(1)
                .toLowerCase()
          }}
        </div>
      </div>
      <el-form-item prop="IsPeelAndApply">
        <div class="peel-and-apply-wrapper">
          <span class="label">{{ $t('text.peel_and_apply') }}</span>
          <el-checkbox v-model="form.IsPeelAndApply"></el-checkbox>
        </div>
      </el-form-item>
    </el-form>
    <AddManufacturer
      ref="addManufacturer"
      @updateManufactures="getManufactures"
    />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import Vue from 'vue'
import moment from 'moment'
import AddManufacturer from '@/components/manage/patients/editPatient/AddManufacturer.vue'
export default {
  data() {
    return {
      manufacturers: [],
      loading: false,
      productLoading: false,
      timeOptions: [
        '00:00:00',
        '01:00:00',
        '02:00:00',
        '03:00:00',
        '04:00:00',
        '05:00:00',
        '06:00:00',
        '07:00:00',
        '08:00:00',
        '09:00:00',
        '10:00:00',
        '11:00:00',
        '12:00:00',
        '13:00:00',
        '14:00:00',
        '15:00:00',
        '16:00:00',
        '17:00:00',
        '18:00:00',
        '19:00:00',
        '20:00:00',
        '21:00:00',
        '22:00:00',
        '23:00:00',
        '24:00:00'
      ],
      form: {
        PatientId: '',
        DayManufacturerId: '',
        DayProductId: '',
        NightProductId: '',
        NightManufacturerId: '',
        DayStartTime: '06:00:00',
        DayEndTime: '18:00:00',
        NightStartTime: '18:00:00',
        NightEndTime: '06:00:00',
        IsPeelAndApply: false
      },
      rules: this.initRules(),
      noneProductOptions: []
    }
  },
  components: {
    AddManufacturer
  },
  mounted() {
    this.getManufactures()
    this.getNonSmartzPad()
  },
  watch: {
    'form.DayManufacturerId': function(newVal, oldVal) {
      if (oldVal !== newVal && oldVal !== '') {
        this.form.DayProductId = ''
      }
    },
    'form.NightManufacturerId': function(newVal, oldVal) {
      if (oldVal !== newVal && oldVal !== '') {
        this.form.NightProductId = ''
      }
    },
    'form.DayStartTime': function() {
      this.calculateNightSection()
    },
    'form.DayEndTime': function() {
      this.calculateNightSection()
    },
    'form.NightStartTime': function() {
      this.calculateDaySection()
    },
    'form.NightEndTime': function() {
      this.calculateDaySection()
    }
  },
  computed: {
    // Dynamically calculate the product list according to the selected manufacturer
    dayProductOptions() {
      let options = []

      if (this.form.DayManufacturerId) {
        this.manufacturers.forEach(manufacturer => {
          if (manufacturer.id === this.form.DayManufacturerId) {
            options = manufacturer.products.filter(item => item.isEnabled)
          }
        })
      } else {
        // if user havn't select manufacturer, then show none product list
        options = this.noneProductOptions
      }
      return options
    },
    nightProductOptions() {
      let options = []

      if (this.form.NightManufacturerId) {
        this.manufacturers.forEach(manufacturer => {
          if (manufacturer.id === this.form.NightManufacturerId) {
            options = manufacturer.products.filter(item => item.isEnabled)
          }
        })
      } else {
        // if user havn't select manufacturer, then show none product list
        options = this.noneProductOptions
      }
      return options
    }
  },
  methods: {
    initRules() {
      return {
        // DayManufacturerId: [
        //   {
        //     required: true,
        //     message: this.$t('text.please_select_manufacturer'),
        //     trigger: 'blur'
        //   }
        // ],
        // NightManufacturerId: [
        //   {
        //     required: true,
        //     message: this.$t('text.please_select_manufacturer'),
        //     trigger: 'blur'
        //   }
        // ],
        // DayProductId: [
        //   {
        //     required: true,
        //     message: this.$t('text.please_select_product'),
        //     trigger: 'blur'
        //   }
        // ],
        // NightProductId: [
        //   {
        //     required: true,
        //     message: this.$t('text.please_select_product'),
        //     trigger: 'blur'
        //   }
        // ],
        DayStartTime: [
          {
            required: true,
            message: this.$t('text.please_select_time_period'),
            trigger: 'blur'
          }
        ],
        DayEndTime: [
          {
            required: true,
            message: this.$t('text.please_select_time_period'),
            trigger: 'blur'
          }
        ],
        NightStartTime: [
          {
            required: true,
            message: this.$t('text.please_select_time_period'),
            trigger: 'blur'
          }
        ],
        NightEndTime: [
          {
            required: true,
            message: this.$t('text.please_select_time_period'),
            trigger: 'blur'
          }
        ]
      }
    },
    openDialog() {
      this.$refs.addManufacturer.openDialog()
    },
    calculateNightSection() {
      // If the day time period is entered, the night time period will be displayed automatically; If the daytime period is 24 hours, the nighttime section is not required
      if (this.form.DayStartTime && this.form.DayEndTime) {
        if (this.form.DayStartTime === this.form.DayEndTime) {
          this.form.NightStartTime = this.form.NightEndTime = ''
          this.modifyNightSectionRequired(false)
        } else {
          this.form.NightStartTime = this.form.DayEndTime
          this.form.NightEndTime = this.form.DayStartTime
          this.modifyNightSectionRequired(true)
        }
      }
    },
    calculateDaySection() {
      if (this.form.NightStartTime && this.form.NightEndTime) {
        if (this.form.NightStartTime === this.form.NightEndTime) {
          this.form.DayStartTime = this.form.DayEndTime = ''
          this.modifyDaySectionRequird(false)
        } else {
          this.form.DayStartTime = this.form.NightEndTime
          this.form.DayEndTime = this.form.NightStartTime
          this.modifyDaySectionRequird(true)
        }
      }
    },
    modifyNightSectionRequired(required) {
      Vue.set(this.rules.NightStartTime, 0, {
        ...this.rules.NightStartTime[0],
        required: required
      })
      Vue.set(this.rules.NightEndTime, 0, {
        ...this.rules.NightEndTime[0],
        required: required
      })
      // Vue.set(this.rules.NightManufacturerId, 0, {
      //   ...this.rules.NightManufacturerId[0],
      //   required: required
      // })
      // Vue.set(this.rules.NightProductId, 0, {
      //   ...this.rules.NightProductId[0],
      //   required: required
      // })
    },
    modifyDaySectionRequird(required) {
      Vue.set(this.rules.DayStartTime, 0, {
        ...this.rules.DayStartTime[0],
        required: required
      })
      Vue.set(this.rules.DayEndTime, 0, {
        ...this.rules.DayEndTime[0],
        required: required
      })
      // Vue.set(this.rules.DayManufacturerId, 0, {
      //   ...this.rules.DayManufacturerId[0],
      //   required: required
      // })
      // Vue.set(this.rules.DayProductId, 0, {
      //   ...this.rules.DayProductId[0],
      //   required: required
      // })
    },
    getManufactures() {
      this.loading = true
      ApiService.GetOrganisationManufacturer(
        this.$store.getters[`user/selecteOrganisationId`]
      )
        .then(response => {
          this.loading = false
          let params = response.data.data.map(item => {
            return {
              manufacturerId: item.ManufacturerId,
              code: item.Code
            }
          })
          if (params && params.length) {
            this.getManufacturersByIds(params)
          } else {
            this.manufacturers = []
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getManufacturersByIds(params) {
      this.loading = true
      ApiService.GetManufacturersByIds(params)
        .then(response => {
          this.loading = false
          this.manufacturers = response.data.data
            .filter(item => item.isEnabled)
            .map(item => {
              return {
                ...item,
                disabled: moment(
                  item.manufacturerCodes.expiryDateTime
                ).isBefore(moment())
              }
            })

          // support user can desect manufacturer
          if (this.manufacturers.length) {
            this.manufacturers.unshift({
              id: 0,
              name: this.$t('text.none')
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getNonSmartzPad() {
      this.productLoading = true
      ApiService.GetNonSmartzPad()
        .then(response => {
          this.productLoading = false
          this.noneProductOptions = response.data.data.map(item => {
            return {
              id: item.Id,
              productName: item.ProductName
            }
          })
        })
        .catch(() => {
          this.productLoading = false
        })
    }
  }
}
</script>
